import React, { Component } from 'react';

export default class Table_Footer extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<thead>
				<tr>
					<th className="table-header">{this.props.receiver.getString("name")}</th>
					{/* Returns each zone for Weekdays */}
					{Object.keys(this.props.price_info.zone.weekday).map((zone) => {
						if (this.props.price_info.zone.weekday[zone].enable) {
							return (
								<th className="table-header">{this.props.receiver.getString("weekday") + "\n" + this.props.price_info.zone.weekday[zone].name}</th>
							)
						} else {
							return null;
						}
					})}

					{/* Returns each zone for Holidays */}
					{Object.keys(this.props.price_info.zone.holiday).map((zone) => {
						if (this.props.price_info.zone.holiday[zone].enable) {
							return (
								<th className="table-header">{this.props.receiver.getString("holiday") + "\n" + this.props.price_info.zone.holiday[zone].name}</th>
							)
						} else {
							return null;
						}
					})}
				</tr>
			</thead>
		)
	}
}